import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp?: number;
  sub?: string;
}

/**
 * Returns true if the token is missing, malformed, or past its `exp`.
 * The 30s skew guards against a token that expires mid-request.
 */
export function isTokenExpired(token: string | null): boolean {
  if (!token) return true;
  try {
    const { exp } = jwtDecode<JwtPayload>(token);
    if (!exp) return true;
    return Date.now() >= exp * 1000 - 30_000;
  } catch {
    // Malformed / tampered token
    return true;
  }
}

/**
 * Returns a valid (present, decodable, non-expired) token, or null.
 * Clears an invalid token from storage as a side effect so the app never
 * renders privileged UI on the strength of a dead token.
 */
export function getValidToken(): string | null {
  const token = localStorage.getItem('token');
  if (isTokenExpired(token)) {
    if (token) localStorage.removeItem('token');
    return null;
  }
  return token;
}
